import { emptyKerioRule } from "./kerioAst.js";
const CONDITION_LABELS = {
    CtFrom: "From",
    CtTo: "To",
    CtCc: "Cc",
    CtSender: "Sender",
    CtRecipient: "Recipient",
    CtEnvelopeSender: "Envelope sender",
    CtEnvelopeRecipient: "Envelope recipient",
    CtSubject: "Subject",
    CtAttachment: "Has attachment",
    CtSize: "Size",
    CtSpam: "Is spam",
    CtAll: "All messages",
};
const COMPARATOR_LABELS = {
    CcEqual: "is",
    CcContain: "contains",
    CcNotContain: "does not contain",
    CcNotEqual: "is not",
    CcUnder: "under",
    CcOver: "over",
    CcNoComparator: "(none)",
};
const ACTION_LABELS = {
    FaKeep: "Keep",
    FaDiscard: "Discard",
    FaStop: "Stop processing",
    FaFileInto: "File into folder",
    FaRedirect: "Redirect",
    FaCopyToAddress: "Copy to address",
    FaReject: "Reject",
    FaNotify: "Notify",
    FaSetReadFlag: "Mark as read",
    FaAutoReply: "Auto-reply",
    FaAddHeader: "Add header",
    FaSetHeader: "Set header",
    FaRemoveHeader: "Remove header",
    FaAddRecipient: "Add recipient",
};
export function conditionTargetLabel(target) {
    return CONDITION_LABELS[target] ?? target;
}
export function comparatorLabel(comp) {
    return COMPARATOR_LABELS[comp] ?? comp;
}
export function actionTypeLabel(type) {
    return ACTION_LABELS[type] ?? type;
}
export const CONDITION_TARGETS = [
    "CtFrom",
    "CtTo",
    "CtCc",
    "CtSender",
    "CtRecipient",
    "CtEnvelopeSender",
    "CtEnvelopeRecipient",
    "CtSubject",
    "CtAttachment",
    "CtSize",
    "CtSpam",
    "CtAll",
];
export const TEXT_COMPARATORS = [
    "CcEqual",
    "CcContain",
    "CcNotContain",
    "CcNotEqual",
];
export const SIZE_COMPARATORS = ["CcUnder", "CcOver"];
export const ACTION_TYPES = [
    "FaKeep",
    "FaDiscard",
    "FaStop",
    "FaFileInto",
    "FaRedirect",
    "FaCopyToAddress",
    "FaReject",
    "FaNotify",
    "FaSetReadFlag",
    "FaAutoReply",
    "FaAddHeader",
    "FaSetHeader",
    "FaRemoveHeader",
    "FaAddRecipient",
];
export function defaultComparatorForTarget(target) {
    if (target === "CtAttachment" || target === "CtSpam" || target === "CtAll") {
        return "CcNoComparator";
    }
    if (target === "CtSize") {
        return "CcOver";
    }
    return "CcContain";
}
export function describeKerioRule(rule) {
    const cond = rule.conditions.length === 0
        ? "no conditions"
        : rule.conditions
            .map((c) => {
            const t = conditionTargetLabel(c.testedTarget);
            if (c.comparator === "CcNoComparator")
                return t;
            return `${t} ${comparatorLabel(c.comparator)} ${c.parameters.join(", ")}`;
        })
            .join(rule.evaluationMode === "EmAnyOf" ? " OR " : " AND ");
    const acts = rule.actions.length === 0
        ? "no actions"
        : rule.actions
            .map((a) => {
            const label = actionTypeLabel(a.type);
            return a.parameters.length ? `${label} (${a.parameters.join(", ")})` : label;
        })
            .join(", ");
    return `${rule.description || "Rule"}: if ${cond} → ${acts}`;
}
export const KERIO_PALETTE = [
    {
        id: "new-rule",
        label: "New rule",
        kind: "rule",
        createRule: () => emptyKerioRule(),
    },
    {
        id: "from-contains",
        label: "From contains…",
        kind: "condition",
        createRule: () => ({
            ...emptyKerioRule(),
            description: "From filter",
            conditions: [
                { testedTarget: "CtFrom", comparator: "CcContain", parameters: [""] },
            ],
        }),
    },
    {
        id: "subject-contains",
        label: "Subject contains…",
        kind: "condition",
        createRule: () => ({
            ...emptyKerioRule(),
            description: "Subject filter",
            conditions: [
                { testedTarget: "CtSubject", comparator: "CcContain", parameters: [""] },
            ],
        }),
    },
    {
        id: "is-spam",
        label: "Is spam → Junk",
        kind: "rule",
        createRule: () => ({
            ...emptyKerioRule(),
            description: "Move spam to Junk",
            conditions: [
                { testedTarget: "CtSpam", comparator: "CcNoComparator", parameters: [] },
            ],
            actions: [{ type: "FaFileInto", parameters: ["Junk E-mail"] }],
        }),
    },
    {
        id: "fileinto",
        label: "File into folder",
        kind: "action",
        createRule: () => ({
            ...emptyKerioRule(),
            description: "File into folder",
            actions: [{ type: "FaFileInto", parameters: [""] }],
        }),
    },
    {
        id: "redirect",
        label: "Redirect",
        kind: "action",
        createRule: () => ({
            ...emptyKerioRule(),
            description: "Redirect",
            actions: [{ type: "FaRedirect", parameters: [""] }],
        }),
    },
];
